(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
/* Kazdy <ins> wymaga wlasnego push(). Robimy to po zaladowaniu
               DOM, bo makro moglo wyrenderowac sie ponizej tego skryptu. */
            (function () {
                var stanSieci = function () {
                    document.documentElement.classList.toggle('jest-offline', !navigator.onLine);
                };
                stanSieci();
                window.addEventListener('online', stanSieci);
                window.addEventListener('offline', stanSieci);
                var start = function () {
                    var sloty = document.querySelectorAll('ins[data-pewniaki-ad="pending"]');
                    window.adsbygoogle = window.adsbygoogle || [];
                    // Collapse only Google's confirmed no-fill; no timeout guessing.
                    // If visible, wait until it leaves the viewport to avoid a jump.
                    sloty.forEach(function (slot) {
                        var box = slot.closest('[data-reklama]');
                        if (!box || !('MutationObserver' in window)) return;
                        var pending = false;
                        var collapse = function () {
                            if (!pending) return;
                            var r = box.getBoundingClientRect();
                            if (r.bottom <= 0 || r.top >= window.innerHeight || r.width === 0) {
                                box.hidden = true;
                                pending = false;
                            }
                        };
                        var update = function () {
                            var state = slot.getAttribute('data-ad-status');
                            if (state === 'filled') { pending = false; box.hidden = false; }
                            else if (state === 'unfilled') { pending = true; collapse(); }
                        };
                        new MutationObserver(update).observe(slot, {attributes:true, attributeFilter:['data-ad-status']});
                        window.addEventListener('scroll', collapse, {passive:true});
                        window.addEventListener('resize', collapse, {passive:true});
                        update();
                    });

                    /* Loader Google i CMP pozostaja w head. Jednostka dostaje
                       klase adsbygoogle dopiero przed swoim jedynym push().
                       Dzieki temu Google nie wybierze oczekujacej stopki zamiast
                       widocznego slotu. Rezerwacja wysokosci pozostaje w CSS. */
                    var request = function (slot, szerokosc) {
                        if (slot.getAttribute('data-pewniaki-ad') !== 'pending' ||
                            szerokosc <= 0) return;
                        slot.setAttribute('data-pewniaki-ad', 'requested');
                        slot.classList.remove('reklama-pending');
                        slot.classList.add('adsbygoogle');
                        try { window.adsbygoogle.push({}); } catch (e) {
                            slot.setAttribute('data-pewniaki-ad', 'error');
                        }
                    };
                    var observer = 'IntersectionObserver' in window
                        ? new IntersectionObserver(function (entries) {
                            entries.forEach(function (entry) {
                                if (entry.isIntersecting) {
                                    request(entry.target, entry.boundingClientRect.width);
                                    if (entry.target.getAttribute('data-pewniaki-ad') !== 'pending')
                                        observer.unobserve(entry.target);
                                }
                            });
                        }, {rootMargin: __pewniaki_inline_cfg[0]}) : null;
                    var check = function () {
                        var wysokosc = window.innerHeight;
                        var pomiary = Array.prototype.map.call(sloty, function (slot) {
                            return {slot: slot, box: slot.getBoundingClientRect()};
                        });
                        pomiary.forEach(function (pomiar) {
                            var box = pomiar.box;
                            if (box.width > 0 && box.bottom >= -200 &&
                                box.top <= wysokosc + 200) request(pomiar.slot, box.width);
                        });
                    };
                    for (var i = 0; i < sloty.length; i++) {
                        if (observer) observer.observe(sloty[i]);
                    }
                    /* Obserwator dostarcza pomiar po renderowaniu. Odczyt tutaj
                       wymuszal ponowne przeliczenie calego ukladu strony. */
                    if (!observer) check();
                    /* Resize obejmuje rowniez sloty desktop po obrocie telefonu. */
                    window.addEventListener('resize', check, {passive: true});
                    if (!observer) window.addEventListener('scroll', check, {passive: true});
                };
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', start);
                } else {
                    start();
                }
            })();
})();
